var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTypeJp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 400 125",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 105.58 90.88 L 105.58 0 L 10.28 0 L 10.28 32.5 L 71.57 32.5 L 71.57 90.88 L 0 90.88 L 0 125 L 132.25 125 L 132.25 90.88 L 105.58 90.88 Z M 400 82.85 L 400 48.74 L 278.53 48.74 L 278.53 82.85 L 322.53 82.85 L 322.53 125 L 356.03 125 L 356.03 82.85 L 400 82.85 Z M 329.17 0 L 329.17 32.5 L 278.53 32.5 L 278.53 0 L 329.17 0 Z M 400 32.5 L 400 0 L 377.05 0 L 377.05 32.5 L 400 32.5 Z M 365.1 0 L 365.1 32.5 L 342.14 32.5 L 342.22 0 L 365.09 0 L 365.1 0 Z M 248.48 90.88 L 248.48 0 L 153.18 0 L 153.18 32.5 L 214.46 32.5 L 214.46 90.88 L 145.88 90.88 L 145.88 125 L 275.15 125 L 275.15 90.88 L 248.48 90.88 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTypeJp);
export default __webpack_public_path__ + "static/media/logo_type_jp.0434ae510aa3eec8f5dfb0f9eb18b5a5.svg";
export { ForwardRef as ReactComponent };